<template>
  <el-popover ref="roomAdult" placement="bottom" trigger="click" @show="showCallback">
    <slot>
      <div class="popBox">
        <div class="tips-content">
          <i class="iconfont yj-icon-tubiao-jinggao"></i>&nbsp;
          <span>海外酒店按人数收费，请准确选择人数间数</span>
        </div>
        <div class="popItem">
          <div>入住间数</div>
          <div class="edit-control">
            <i :class="`iconfont yj-icon-remove-2 f20 ${roomNum > 1 ? 'ctext' : 'cdisable'}`"
              @click="roomNumChange('sub')"></i>
            <div class="flex1">{{ roomNum }}间</div>
            <i :class="`iconfont yj-icon-circle-plus-2 f20 ${roomNum < maxRoomNum ? 'ctext' : 'cdisable'}`"
              @click="roomNumChange('add')"></i>
          </div>
        </div>
        <div class="popItem">
          <div>单个房间成人数</div>
          <div class="edit-control">
            <i :class="`iconfont yj-icon-remove-2 f20 ${adultNum > 1 ? 'ctext' : 'cdisable'}`"
              @click="adultNumChange('sub')"></i>
            <div class="flex1">{{ adultNum }}人</div>
            <i :class="`iconfont yj-icon-circle-plus-2 f20 ${adultNum < maxCxrNum ? 'ctext' : 'cdisable'}`"
              @click="adultNumChange('add')"></i>
          </div>
        </div>

        <div class="btn" @click.stop="confirm()">
          <span>确定</span>
        </div>
      </div>
    </slot>
    <div slot="reference" class="adult-style">
      <div> {{ rNum }}间房，{{ aNum }}人 </div>
      <div>
        <i class="el-icon-arrow-down" style="color: #666;"></i>
      </div>
    </div>
  </el-popover>
</template>
<script>
export default {
  data() {
    return {
      roomNum: 1,
      adultNum: 1,
      maxCxrNum: 10,
      maxRoomNum: 10,
    }
  },
  props: {
    rNum: Number,
    aNum: Number,
    cxrLength: {
      type: Number,
      default: 0,
    },
    tripType: {
      type: [Number, String],
      default: '0'
    }
  },
  computed: {
    adultNumCanSub() {
      if (this.cxrLength > this.maxRoomNum) {
        return false;
      }
      return this.adultNum > 1;
    }
  },
  watch: {
    cxrLength: {
      handler(v) {
        // 因私不根据人去设置
        if (this.tripType == 2) return;
        this.maxRoomNum = v > 10 ? 10 : v;
        this.maxCxrNum = v > 10 ? 10 : v;
      },
      immediate: true,
    },
    tripType: {
      handler(v) {
        if (v == 1) {
          this.maxRoomNum = this.cxrLength > 10 ? 10 : props.cxrLength;
          this.maxCxrNum = this.cxrLength > 10 ? 10 : props.cxrLength;
          return;
        }
        this.maxRoomNum = 10;
        this.maxCxrNum = 10;
      },
      immediate: true,
    },
    rNum: {
      handler(v) {
        this.roomNum = v;
        // console.log('rNum === ', v);
      },
      immediate: true,
    },
    aNum: {
      handler(v) {
        this.adultNum = v || 1;
        // console.log('aNum === ', v);
      },
      immediate: true,
    },
  },
  methods: {
    showCallback() {
      this.roomNum = this.rNum;
      this.adultNum = this.aNum || 1;
    },
    roomNumChange(type) {
      if (type == 'add') {
        if (this.roomNum >= this.maxRoomNum) return;
        this.roomNum += 1;
        return;
      }
      if (this.roomNum <= 1) return;
      let length = this.cxrLength || 0;
      if (this.roomNum <= Math.ceil(length / this.adultNum)) {
        this.$message.warning(`每间入住${this.adultNum}人，不得少于${Math.ceil(length / this.adultNum)}间房`)
        return;
      }
      this.roomNum -= 1;
    },
    adultNumChange(type) {
      if (type == 'add') {
        if (this.adultNum >= this.maxCxrNum) return;
        this.adultNum += 1;
        return;
      }
      if (!this.adultNumCanSub) return;
      this.adultNum -= 1;
    },
    confirm() {
      this.$refs.roomAdult.doClose()

      this.$emit('select', {
        roomNum: this.roomNum,
        adultNum: this.adultNum,
      })
    },
  }
}
</script>

<style scoped>
.popBox {
  width: 284px;
  /* height: 193px; */
}

.tips-content {
  height: 40px;
  border-radius: 4px;
  opacity: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 16px;
  background: #F2F8FD;
  font-size: 12px;
  color: #1B8CFF;
  margin-bottom: 10px;
}

.popItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  height: 40px;
}

.edit-control {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.flex1 {
  flex: 1;
  text-align: center;
  width: 60px;
}

.f20 {
  font-size: 20px;
}

.adult-style {
  width: 150px;
  height: 45px;
  border: 2px solid #d9e1ed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px;
  cursor: pointer;
}

.btn {
  height: 40px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 24px;
  background: #1B8CFF;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
  user-select: none;
}

.btn:hover {
  background: rgba(27, 140, 255, 0.9);

}

.ctext {
  color: #222222;
}

.cdisable {
  color: #ccc;
}
</style>